import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/ko';
import classNames from 'classnames';
import { Calendar, momentLocalizer, View as TView, Views } from 'react-big-calendar';
import { useFormik } from 'formik';
import { Calendar as DatePicker } from 'react-date-range';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../layout/SubHeader/SubHeader';
import ko from 'date-fns/locale/ko';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Popovers from '../../../components/bootstrap/Popovers';
import { demoPagesMenu } from '../../../menu';

import useDarkMode from '../../../hooks/useDarkMode';
import styled from 'styled-components';
import { db, authService } from '../../../Firebase';

import { collection, getDocs, onSnapshot, setDoc, doc, deleteDoc } from 'firebase/firestore';
import { uuidv4 } from '@firebase/util';
import Spinner from '../../../components/bootstrap/Spinner';

const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 44px;
	align-items: center;
	justify-content: center;
	min-width: 1540px;
`;

const HeaderItem = styled.div`
	flex: 1;
	display: flex;
	min-width: 140px;
	height: 44px;
	font-size: 16px;
	font-weight: bold;
	color: #333;
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
	border-left: 1px solid #eee;
	align-items: center;
	text-align: center;
	justify-content: center;
`;

const Row = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	min-width: 1540px;
	border-right: 1px solid #eee;
	border-bottom: 1px solid #eee;
	height: 88px;
`;

const ColItem = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 88px;
	min-width: 140px;
	border-left: 1px solid #eee;
	align-items: center;
	text-align: center;
	justify-content: center;
	font-size: 15px;
	font-weight: bold;
	color: #aaa;
`;

const Name = styled.div`
	color: #333;
`;

const FLOOR_LABEL = ['쉼누리', '배움누리', '상상누리', '창작누리', '꿈누리', '체육관', '실외공간'];
const TIMES = [
	'일과전',
	'1교시',
	'2교시',
	'3교시',
	'4교시',
	'점심시간',
	'5교시',
	'6교시',
	'7교시',
	'일과후',
];

const ROOMS_1F = [
	{ code: '1-1', label: '에듀카페' },
	{ code: '1-2', label: '어울림광장' },
	{ code: '1-3', label: '햇살' },
	{ code: '1-4', label: '풀잎' },
	{ code: '1-5', label: '물결' },
	{ code: '1-6', label: '실외데크' },
];

const ROOMS_2F = [
	{ code: '2-1', label: 'ICT Pod' },
	{ code: '2-2', label: '다락방' },
	{ code: '2-3', label: '배움 1실' },
	{ code: '2-4', label: '배움 2실' },
	{ code: '2-5', label: '교사쉼터' },
	{ code: '2-6', label: '러닝센터' },
	{ code: '2-7', label: '북카페' },
	{ code: '2-8', label: '사랑방' },
];

const ROOMS_3F = [
	{ code: '3-1', label: 'Science Lab 1' },
	{ code: '3-2', label: 'Science Lab 2' },
	{ code: '3-3', label: '상상체험실' },
	{ code: '3-4', label: '융복합실' },
	{ code: '3-5', label: '상상 1실' },
	{ code: '3-6', label: '상상 2실' },
	{ code: '3-7', label: '상상쉼터' },
];

const ROOMS_4F = [
	{ code: '4-1', label: 'Maker Space' },
	{ code: '4-2', label: 'Home Economincs & Technology Room' },
	{ code: '4-3', label: 'Art Studio' },
	{ code: '4-4', label: '컴퓨터실' },
	{ code: '4-5', label: '창작 1실' },
	{ code: '4-6', label: '창작 2실' },
	{ code: '4-7', label: '3D 프린터실' },
	{ code: '4-8', label: '창작쉼터' },
	{ code: '4-9', label: '학습포켓' },
];

const ROOMS_5F = [
	{ code: '5-1', label: '커뮤니티홀' },
	{ code: '5-2', label: '꿈쉼터' },
	{ code: '5-3', label: '진로활동실' },
	{ code: '5-4', label: 'Band Room' },
	{ code: '5-5', label: 'Music Room' },
	{ code: '5-7', label: '꿈 1실' },
	{ code: '5-8', label: '꿈 2실' },
	{ code: '5-6', label: '꿈 3실' },
	{ code: '5-9', label: '수업집중연구실' },
	{ code: '5-10', label: '학습포켓' },
];

const ROOMS_6F = [
	{ code: '6-1', label: '체육관' },
	{ code: '6-2', label: '무용실' },
];

const ROOMS_7F = [
	{ code: '7-1', label: '실외운동장' },
	{ code: '7-2', label: '야외쉼터' },
];

const localizer = momentLocalizer(moment);
const now = new Date();

const DashboardPage = () => {
	const { darkModeStatus, themeStatus } = useDarkMode();
	const [date, setDate] = useState(now);
	const [floor, setFloor] = useState(0);
	const [data, setData] = useState<any[]>([]);
	const [loading, setLoading] = useState(false);

	const [toggleCalendar, setToggleCalendar] = useState(true);

	useEffect(() => {
		const unsubcribe = onSnapshot(collection(db, 'Reservation'), (querySnapshotdoc) => {
			const listData: any[] = [];
			querySnapshotdoc.forEach((docItem: any) => {
				listData.push(docItem.data());
			});
			setData(listData);
		});

		return unsubcribe;
	}, []);

	const addResevation = async (roomCode: any, time: any) => {
		const id = uuidv4();

		await setDoc(doc(db, 'Reservation', id), {
			id: id,
			date: moment(date).format('YYYY/MM/DD'),
			roomCode: roomCode,
			floor: floor,
			time: time,
			reservationName: authService.currentUser?.displayName,
			reservationUid: authService.currentUser?.uid,
		});
	};

	const deleteResevation = async (deleteId: any) => {
		await deleteDoc(doc(db, 'Reservation', deleteId));
	};

	const reservationItemCheck = (time: any, roomCode: any) => {
		const filteredId = data.filter(
			(el) =>
				el.date === moment(date).format('YYYY/MM/DD') &&
				el.floor === floor &&
				el.time === time &&
				el.roomCode === roomCode,
		);
		return filteredId[0];
	};

	return (
		<PageWrapper title='앎삶쉼 예약'>
			<SubHeader>
				<SubHeaderRight>
					<Popovers
						desc={
							<DatePicker
								onChange={(seletedDate) => {
									setLoading(true);
									setDate(seletedDate);
									setTimeout(() => {
										setLoading(false);
									}, 200);
								}}
								date={date}
								minDate={new Date(new Date().setDate(new Date().getDate() - 1))}
								locale={ko}
								color={process.env.REACT_APP_PRIMARY_COLOR}
							/>
						}
						placement='bottom-end'
						className='mw-100'
						trigger='click'>
						<Button size='lg' color={darkModeStatus ? 'light' : 'dark'} isLight>
							{moment(date).format('YYYY년 MM월 DD일 dddd')}
						</Button>
					</Popovers>
				</SubHeaderRight>
			</SubHeader>
			<Page container='fluid' className='w-100'>
				{toggleCalendar && (
					<>
						<div className='row h-100 w-100'>
							<div>
								<Card stretch='full' style={{ minHeight: 680 }} className='w-100'>
									<CardHeader
										style={{
											flexDirection: 'row',
											height: 'auto',
											maxHeight: 240,
											flexWrap: 'wrap',
											justifyContent: 'flex-start',
											width: '100%',
										}}>
										{FLOOR_LABEL.map((item, index) => (
											<Button
												key={item}
												style={{ marginRight: 10, marginTop: 4 }}
												onClick={() => {
													setFloor(index);
												}}
												size='lg'
												color='primary'
												isLight
												isActive={floor === index}>
												{!(index === 6 || index === 5)
													? `${index + 1}층 ${item}`
													: `${item}`}
											</Button>
										))}
									</CardHeader>
									{loading ? (
										<CardBody className='w-100'>
											<div
												style={{
													flex: 1,
													alignItems: 'center',
													justifyContent: 'center',
													marginTop: '15%',
													marginLeft: '50%',
												}}>
												<Spinner
													isGrow={true}
													tag='div'
													color='primary'
													isSmall={false}
													size='5rem'
													inButton={false}
												/>
											</div>
										</CardBody>
									) : (
										<CardBody isScrollable>
											<HeaderWrapper>
												<HeaderItem
													style={{
														borderTopLeftRadius: 10,
														color: '#555',
													}}>
													공간명
												</HeaderItem>
												{TIMES.map((item, index) => (
													<HeaderItem
														key={item}
														style={{
															borderRightStyle: 'solid',
															borderRightWidth:
																index === TIMES.length - 1 ? 1 : 0,
															borderRightColor: '#eee',
															borderTopRightRadius:
																index === TIMES.length - 1 ? 10 : 0,
														}}>
														{item}
													</HeaderItem>
												))}
											</HeaderWrapper>
											{floor === 0 &&
												ROOMS_1F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
											{floor === 1 &&
												ROOMS_2F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
											{floor === 2 &&
												ROOMS_3F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
											{floor === 3 &&
												ROOMS_4F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
											{floor === 4 &&
												ROOMS_5F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
											{floor === 5 &&
												ROOMS_6F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
											{floor === 6 &&
												ROOMS_7F.map((item, index) => (
													<Row key={item.code}>
														<ColItem style={{ color: '#333' }}>
															{item.label}
														</ColItem>
														{TIMES.map((item2, index2) => (
															<ColItem
																key={item2}
																style={
																	reservationItemCheck(
																		item2,
																		item.code,
																	)
																		? {
																				backgroundColor:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? 'rgba(255,161,191,0.2)'
																						: 'rgba(253, 213, 108,0.2)',
																				borderBottomWidth: 1,
																				borderColor: '#eee',
																				color:
																					reservationItemCheck(
																						item2,
																						item.code,
																					)
																						.reservationUid ===
																					authService
																						.currentUser
																						?.uid
																						? '#ffa1bf'
																						: '#FDD56C',
																		  }
																		: {}
																}>
																{reservationItemCheck(
																	item2,
																	item.code,
																) ? (
																	<div style={{ maxWidth: 140 }}>
																		<Name>
																			{
																				reservationItemCheck(
																					item2,
																					item.code,
																				).reservationName
																			}
																		</Name>
																		공간 예약중
																		{reservationItemCheck(
																			item2,
																			item.code,
																		).reservationUid ===
																			authService.currentUser
																				?.uid && (
																			<Button
																				onClick={() => {
																					const deleteId =
																						reservationItemCheck(
																							item2,
																							item.code,
																						).id;
																					deleteResevation(
																						deleteId,
																					);
																				}}
																				color='secondary'
																				style={{
																					fontWeight:
																						'bold',
																				}}>
																				취소하기
																			</Button>
																		)}
																	</div>
																) : (
																	<Button
																		onClick={() => {
																			addResevation(
																				item.code,
																				item2,
																			);
																		}}
																		size='lg'
																		color='success'
																		isLight
																		style={{
																			fontWeight: 'bold',
																		}}>
																		예약하기
																	</Button>
																)}
															</ColItem>
														))}
													</Row>
												))}
										</CardBody>
									)}
								</Card>
							</div>
						</div>
					</>
				)}
			</Page>
		</PageWrapper>
	);
};

export default DashboardPage;
